import React from "react";
import { Link } from "react-router-dom";
import { SealStamp } from "../components/Art";

export default function NotFound() {
  return (
    <section className="notfound" data-testid="notfound-page">
      <SealStamp lines={["404", "HALAMAN"]} />
      <h1 className="notfound__code" style={{ marginTop: "2rem" }}>
        404
      </h1>
      <p className="page-head__lede" style={{ marginTop: "1.5rem" }}>
        Halaman yang Anda cari tidak ada — mungkin tersesat di gang yang salah. Mari kembali ke
        kedai.
      </p>
      <div className="notfound__ctas">
        <Link to="/" className="btn btn--seal" data-testid="notfound-cta-home">
          Kembali ke Beranda
        </Link>
        <Link to="/menu/" className="btn" data-testid="notfound-cta-menu">
          Lihat Menu
        </Link>
      </div>
    </section>
  );
}
